var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodoList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.184,
    height: 37,
    viewBox: "0 0 28.184 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "to-do-list",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M88.022,3.334a3.942,3.942,0,0,0-2.809-1.166H83.42V1.807A1.809,1.809,0,0,0,81.614,0H68.606A1.809,1.809,0,0,0,66.8,1.807v.361H65a3.978,3.978,0,0,0-3.97,3.97L61,33.021A3.972,3.972,0,0,0,64.97,37H85.183a3.978,3.978,0,0,0,3.97-3.97l.03-26.883a3.95,3.95,0,0,0-1.161-2.813ZM68.967,2.168H81.252V4.336H68.967ZM86.988,33.027a1.808,1.808,0,0,1-1.8,1.8H64.97a1.806,1.806,0,0,1-1.8-1.809L63.2,6.141a1.808,1.808,0,0,1,1.8-1.8h1.8V4.7A1.809,1.809,0,0,0,68.606,6.5H81.614A1.809,1.809,0,0,0,83.42,4.7V4.336h1.793a1.806,1.806,0,0,1,1.8,1.809Z",
    transform: "translate(0 0)",
    fill: "#4d6ac4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M247.183,172.168h7.7a1.084,1.084,0,0,0,0-2.168h-7.7a1.084,1.084,0,0,0,0,2.168Z",
    transform: "translate(-171.723 -157.715)",
    fill: "#4d6ac4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M247.183,272.168h7.7a1.084,1.084,0,0,0,0-2.168h-7.7a1.084,1.084,0,0,0,0,2.168Z",
    transform: "translate(-171.723 -250.488)",
    fill: "#4d6ac4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M254.915,370h-7.732a1.084,1.084,0,0,0,0,2.168h7.732a1.084,1.084,0,0,0,0-2.168Z",
    transform: "translate(-171.723 -343.262)",
    fill: "#4d6ac4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M133.841,140.081l-2.5,2.5-.589-.589a1.084,1.084,0,1,0-1.533,1.533l1.356,1.356a1.084,1.084,0,0,0,1.533,0l3.266-3.266a1.084,1.084,0,0,0-1.533-1.533Z",
    transform: "translate(-62.995 -129.664)",
    fill: "#4d6ac4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M133.841,247.719l-2.5,2.5-.589-.589a1.084,1.084,0,1,0-1.533,1.533l1.356,1.356a1.084,1.084,0,0,0,1.533,0l3.266-3.266a1.084,1.084,0,0,0-1.533-1.533Z",
    transform: "translate(-62.995 -229.523)",
    fill: "#4d6ac4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M133.841,347.719l-2.5,2.5-.589-.589a1.084,1.084,0,1,0-1.533,1.533l1.356,1.356a1.084,1.084,0,0,0,1.533,0l3.266-3.266a1.084,1.084,0,0,0-1.533-1.533Z",
    transform: "translate(-62.995 -322.296)",
    fill: "#4d6ac4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoList);
export default __webpack_public_path__ + "static/media/todoList.c47a8d87427224c9d286ce391dce92de.svg";
export { ForwardRef as ReactComponent };